var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.defaultPage)?_c('SecuritySettingInner'):_vm._e(),(_vm.is8V)?_c('SecuritySettingInnerBv'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }